module.exports = __webpack_public_path__ + "static/media/square.389f411e.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/claims/details/square.png
// module id = 2098
// module chunks = 147